import { render, staticRenderFns } from "./daisy.vue?vue&type=template&id=39c020fa"
import script from "./daisy.vue?vue&type=script&lang=ts"
export * from "./daisy.vue?vue&type=script&lang=ts"
import style0 from "./daisy.vue?vue&type=style&index=0&id=39c020fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports